import type { TimeStreamAsset } from '../schema';

const MAGIC_NUMBER = Math.pow(2, 16);

export default function isCapturedAsset(asset: TimeStreamAsset) {
    // currently captured assets are stored at position = MAGIC_NUMBER
    return asset.isCaptured || asset.bounds.x === MAGIC_NUMBER || asset.bounds.y === MAGIC_NUMBER;
}
